module.exports = __webpack_public_path__ + "img/plus.2de6962b.svg";